(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus/assets/javascripts/views/start.js') >= 0) return;  svs.modules.push('/modules/spelpaus/assets/javascripts/views/start.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.spelpaus.views.Start = Marionette.View.extend({
    template: function(data) {
      return svs.spelpaus.templates.start(data);
    },
    regions: {
      spelpausInfoRegion: '#spelpausInfoRegion'
    },
    behaviors: {
      ServerSideRendering: {
        regionSetup: {
          spelpausInfoRegion: {
            view: svs.spelpaus.views.Info
          }
        }
      }
    },
    events: {
      'click .js-logout-spelpaus': 'logoutUser'
    },
    logoutUser: function() {
      if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
        svs.core.userSession.logout();
      }
    }
  });
})(Backbone, _, svs);

 })(window);